<!-- @format -->

<script>
  // import { Router } from "svelte-spa-router/Router.svelte";
  // import { Route } from "svelte-spa-router/Route.svelte";
  // import { Link } from "svelte-spa-router/Link";
  import Home from "./routes/Home.svelte";
  import WidelyHome from "./routes/widely/WidelyHome.svelte";
  import WidelyTerms from "./routes/widely/WidelyTerms.svelte";
  import WidelyPrivacyPolicy from "./routes/widely/WidelyPrivacyPolicy.svelte";

  import ShortcaseHome from "./routes/shortcase/ShortcaseHome.svelte";
  import ShortcasePrivacyPolicy from "./routes/shortcase/PrivacyPolicy.svelte";
  import ShortcaseTerms from "./routes/shortcase/Terms.svelte";

  import VishopHome from "./routes/vishop/VishopHome.svelte";
  import VishopPrivacyPolicy from "./routes/vishop/PrivacyPolicy.svelte";
  import VishopTerms from "./routes/vishop/Terms.svelte";
  import HealthtokHome from "./routes/healthtok/HealthtokHome.svelte";
  import PrivacyPolicy from "./routes/PrivacyPolicy.svelte";
  import Terms from "./routes/Terms.svelte";
  // import Privacy from "./routes/PrivacyPolicy.svelte";
  // import { Router, Route, Link } from "svelte-spa-router";
  // import { Router } from "svelte-spa-router";
  // import Router from "svelte-spa-router";
  // import { Router } from "svelte-spa-router/Router";
  import Router from "svelte-spa-router/Router.svelte";
  // import routes from "~/routes";
  //path와 라우팅 할 컴포넌트

  // var routesMode = "widely";
  // var routesMode = "vishop";
  // var routesMode = "healthtok";
  var routesMode = "shortcase";
  var routes;

  if (routesMode === "widely") {
    routes = {
      "/": WidelyHome,
      "/privacy-policy": WidelyPrivacyPolicy,
      "/terms": WidelyTerms,
    };
  } else if (routesMode === "vishop") {
    routes = {
      "/": VishopHome,
      "/privacy": VishopPrivacyPolicy,
      "/terms": VishopTerms,
    };
  } else if (routesMode === "healthtok") {
    routes = {
      "/": HealthtokHome,
      "/privacy": PrivacyPolicy,
      "/terms": Terms,
    };
  } else if (routesMode === "shortcase") {
    routes = {
      "/": ShortcaseHome,
      "/privacy": ShortcasePrivacyPolicy,
      "/terms": ShortcaseTerms,
    };
  }
</script>

<style>
  :global(body) {
    /* overscroll-behavior: none; 전체 페이지에 대한 반동 효과 비활성화 */
    background-color: #1b1a1d;
  }
</style>

<!-- <Router>
  <nav>
    <Link to="/">Home</Link>
    <Link to="/privacy-policy">Privacy Policy</Link>
  </nav>

  <Route path="/" component={Home} />
  <Route path="/privacy-policy" component={Privacy} />
</Router> -->

<main>
  <Router {routes} />
</main>
<!-- <script>
  import routes from "./routes";
  import Router from "svelte-spa-router";
</script>

<main>
  <Router {routes} />
</main> -->

<!-- <script>
  import { Router, Link, Route } from "svelte-routing";
  import Web2 from "./Web2.svelte";
  import Privacy from "./PrivacyPolicy.svelte";

  export let url = "/";
</script>

<Router {url}>
  <nav>
    <Link to="/">Web2</Link>
    <Link to="/privacy">Privacy</Link>
  </nav>
  <div>
    <Route path="/privacy" component={Privacy} />
    <Route path="/"><Web2 /></Route>
  </div>
</Router> -->

<!-- <script>
	export let name;
</script>

<main>
	<h1>Hello {name}!</h1>
	<p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style> -->
